/* tslint:disable */
/* eslint-disable */
export enum WorkChangelogStatusEnum {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Obsolete = 'OBSOLETE'
}
